import type { CSSProperties, MutableRefObject } from 'react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { spring } from '@elfsight/widget-utils';
import { animate } from 'framer-motion';

export function AnimatedNumber({
  value,
  formatter,
  duration,
  style
}: {
  value?: number;
  duration?: number;
  formatter?: (value: number | undefined) => string;
  style?: CSSProperties;
}) {
  const contentSpanRef = useRef<HTMLSpanElement>(null);
  const valueRef = useRef<number>(0) as MutableRefObject<number>;

  const updateVisibleValue = (derivedValue: number | undefined) => {
    if (contentSpanRef.current) {
      contentSpanRef.current.textContent = formatter
        ? formatter(derivedValue)
        : derivedValue
          ? derivedValue.toFixed(0).toString()
          : '—';
    }
  };

  useEffect(() => {
    const numericValue = Number(value);
    animate(valueRef.current, numericValue, {
      ...spring.default,
      duration: duration ? duration / 1000 : 0.5,
      onUpdate: updateVisibleValue
    });

    valueRef.current = isFinite(numericValue) ? numericValue : 0;
  }, [value, duration]);

  useEffect(() => {
    updateVisibleValue(value === Infinity ? 0 : value);
  }, [formatter]);

  return <Content style={style} ref={contentSpanRef} />;
}

const Content = styled.span``;
